import { BankAccount } from "@/models/api/administration/bankAccounts/BankAccountsList";
import { ContractorBankAccountResponse } from "@/models/api/administration/contractors/ContractorBankAccountResponse";
import { GenericTableRequest } from "@/models/api/GenericTableRequest";
import CancellableHelper from "@/requests/CancellableHelper";

//#region routes
export const URL_GET_CONTRACTORS_BANK_ACCOUNT_PAGED = "/ContractorAdministration/${ContractorId}/BankAccount/Paged";
export const URL_POST_ASSIGN_BANK_ACCOUNT_TO_CONTRACTOR =
  "/ContractorAdministration/${ContractorId}/BankAccount/${BankAccountId}/Assign";
export const URL_POST_UNASSIGN_BANK_ACCOUNT_FROM_CONTRACTOR =
  "/ContractorAdministration/${ContractorId}/BankAccount/${BankAccountId}/Unassign";
export const URL_POST_UNSET_DEFAULT_BANK_ACCOUNT_CONTRACTOR =
  "/ContractorAdministration/${ContractorId}/BankAccount/${BankAccountId}/UnsetDefault";
export const URL_POST_SET_DEFAULT_BANK_ACCOUNT_CONTRACTOR =
  "/ContractorAdministration/${ContractorId}/BankAccount/${BankAccountId}/SetDefault";
export const URL_POST_ADD_NEW_BANK_ACCOUNT_AND_SET_TO_CONTRACTOR =
  "/ContractorAdministration/${ContractorId}/BankAccount/Add";

//#endregion

const _getContractorBankAccountPaged = new CancellableHelper<ContractorBankAccountResponse>(
  URL_GET_CONTRACTORS_BANK_ACCOUNT_PAGED,
  ContractorBankAccountResponse
);
_getContractorBankAccountPaged.jsonSerializer = true;
export const getContractorBankAccount = async (
  genericTableRequest: GenericTableRequest,
  contractorId: string | null
): Promise<ContractorBankAccountResponse> => {
  return await _getContractorBankAccountPaged.get({
    ContractorId: contractorId,
    ...genericTableRequest,
  });
};

const _assignBankAccountToContractor = new CancellableHelper<null>(
  URL_POST_ASSIGN_BANK_ACCOUNT_TO_CONTRACTOR,
  null,
  true
);
export const assignBankAccountToContractor = async (contractorId: string, bankAccountId: number): Promise<null> => {
  return await _assignBankAccountToContractor.post({
    ContractorId: contractorId,
    BankAccountId: bankAccountId,
  });
};

const _unassignBankAccountFromContractor = new CancellableHelper<null>(
  URL_POST_UNASSIGN_BANK_ACCOUNT_FROM_CONTRACTOR,
  null,
  true
);
export const unassignBankAccountFromContractor = async (contractorId: string, bankAccountId: number): Promise<null> => {
  return await _unassignBankAccountFromContractor.post({
    ContractorId: contractorId,
    BankAccountId: bankAccountId,
  });
};

const _unsetDefaultBankAccountContractor = new CancellableHelper<null>(
  URL_POST_UNSET_DEFAULT_BANK_ACCOUNT_CONTRACTOR,
  null,
  true
);
export const unsetDefaultBankAccountContractor = async (contractorId: string, bankAccountId: number): Promise<null> => {
  return await _unsetDefaultBankAccountContractor.post({
    ContractorId: contractorId,
    BankAccountId: bankAccountId,
  });
};

const _setDefaultBankAccountContractor = new CancellableHelper<null>(
  URL_POST_SET_DEFAULT_BANK_ACCOUNT_CONTRACTOR,
  null,
  true
);
export const setDefaultBankAccountContractor = async (contractorId: string, bankAccountId: number): Promise<null> => {
  return await _setDefaultBankAccountContractor.post({
    ContractorId: contractorId,
    BankAccountId: bankAccountId,
  });
};

const _addNewBankAccountAndSetToContractor = new CancellableHelper<null>(
  URL_POST_ADD_NEW_BANK_ACCOUNT_AND_SET_TO_CONTRACTOR,
  null,
  true
);
export const addNewBankAccountAndSetToContractor = async (
  contractorId: string,
  newBankAccount: BankAccount
): Promise<null> => {
  return await _addNewBankAccountAndSetToContractor.post({ ContractorId: contractorId }, newBankAccount);
};
